var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoResults = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 116,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 58L19.776 75.997c-1.961 2.047-1.876 5.374.171 7.335 2.047 1.962 5.374 1.877 7.335-.17l16.206-17.4",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.53 62.776c0 11.878-9.63 21.506-21.507 21.506s-21.505-9.628-21.505-21.506c0-11.877 9.628-21.506 21.505-21.506 11.878 0 21.506 9.629 21.506 21.506z",
    fill: "#fff",
    stroke: "#301C6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.03 55.782l13.987 13.989M67.03 69.77l13.987-13.988",
    stroke: "#301C6B",
    strokeWidth: 5.216,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.518 69.259L25.576 82.053",
    stroke: "#301C6B",
    strokeWidth: 2.326,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.606 62.947l-3.07 3.241s-7.421-1.28-9.383-9.894l3.241-3.497",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.241 61.582l-3.326 3.497",
    stroke: "#FFCBBD",
    strokeWidth: 2.326,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.476 63.715c10.788 0 19.533-8.745 19.533-19.532 0-10.788-8.745-19.533-19.533-19.533-10.787 0-19.532 8.745-19.532 19.533 0 10.787 8.745 19.532 19.532 19.532z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.58 54.333l16.973 16.888M65.58 71.221l16.973-16.888",
    stroke: "#fff",
    strokeWidth: 6.313,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.023 90.412c15.263 0 27.636-12.373 27.636-27.635 0-15.263-12.373-27.635-27.636-27.635-15.262 0-27.635 12.372-27.635 27.635 0 15.263 12.373 27.635 27.636 27.635z",
    fill: "#FECBBE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.238 53.991l17.656 17.57M65.238 71.562l17.656-17.57",
    stroke: "#fff",
    strokeWidth: 6.567,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.888 24.99c-10.662-1.876-20.726 5.204-22.603 15.866-1.876 10.661 5.203 20.726 15.865 22.602 10.662 1.877 20.726-5.203 22.603-15.864 1.876-10.577-5.203-20.727-15.865-22.603zm-3.497 34.716c-8.444 0-15.267-6.824-15.267-15.268S48.947 29.17 57.39 29.17c8.444 0 15.268 6.824 15.268 15.268S65.835 59.705 57.39 59.705z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.476 63.715c10.788 0 19.533-8.745 19.533-19.532 0-10.788-8.745-19.533-19.533-19.533-10.787 0-19.532 8.745-19.532 19.533 0 10.787 8.745 19.532 19.532 19.532z",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.741 62.265l-13.05 13.732c-1.961 2.047-1.876 5.374.17 7.335 2.048 1.962 5.374 1.877 7.336-.17l12.965-13.818M48.606 62.947l-3.07 3.241s-7.421-1.28-9.383-9.894l3.241-3.497",
    stroke: "#311D6C",
    strokeWidth: 2.326,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.124 37.7c-.683-1.791-1.962-2.303-3.839-1.791-1.876.511 1.024-2.644 1.024-2.644l3.923 1.535.512 2.644-1.62.256zM49.288 57.403c-1.706-.853-2.047-2.218-1.28-4.009.768-1.791-2.729.682-2.729.682l1.11 4.094 2.558.768.341-1.535z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoResults);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-results.3ebcf006d65e8a9109d693bd4c8d31d8.svg";